<template>
  <!-- 须知 -->
  <div class="mask" @click.self="closeNotice" v-show="stateNotice">
    <div class="notice">
      <div class="header">
        <div class="left">
          <i class="icon icon-ticket2"></i
          ><span>{{ currentNotice.title }}</span>
        </div>
        <img class="logo" src="~@/assets/image/common/common_logo.png" alt="">
      </div>
      <main>
        <redtitle titleText="购票须知" />
        <div class="temporary" v-html="currentNotice.description"></div>
      </main>

      <div class="payment">
        <div class="left">
          <span>总金额</span><em>￥{{ price }}</em>
        </div>
        <div @click="clickPay" class="right">下一步</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "remind",
  props:{
    currentNotice: {
      type: Object
    },
    stateNotice: {
      type: Boolean
    },
    reserveUrl: {
      type: String
    },
    price: {

    }
  },
  methods: {
    closeNotice(){
      this.$emit('fullEvents', {
        type: 'closeNotice'
      });
    },
    clickPay(){
      this.$emit('fullEvents', {
        type: 'clickPay'
      });
    }
  },
  watch: {
    stateNotice: {
      handler(newValue){
        this.$beyondHiding(newValue)
      },
    }
  }
};
</script>

<style scoped lang='less'>
.mask {
  position: fixed;
  height: 100vh;
  width: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.42);
  z-index: 9;
}
.notice {
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
  .header {
    height: 0.813333rem * 2;
    background: #f1f2f7;
    border-radius: 0.32rem * 2 0.32rem * 2 0 0;
    padding: 0 0.4rem;
    font-size: 0.533333rem;
    color: #222328;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      display: flex;
      align-items: center;
      i {
        width: 0.533333rem;
        height: 0.533333rem;
        margin-right: 0.16rem;
      }
    }
    .logo {
      height: 0.88rem;
    }
  }
  main {
    padding: 0.4rem 0.32rem;
    background: #fff;
    line-height: 1;
    .use {
      .use-title {
        margin: 0.213333rem 0;
        .msg {
          color: #a1a6ba;
          font-size: 0.373333rem;
          margin-right: 1.12rem;
        }
        .msg-dt {
          font-size: 0.32rem;
          color: #333333;
        }
      }
      .use-type {
        line-height: 0.906667rem;
        background: #e4e7f0;
        font-size: 0.373333rem;
        color: #333333;
        font-weight: bold;
        display: flex;
        justify-content: space-between;
        text-align: center;
        span {
          flex: 1;
          &:nth-child(2) {
            flex: 2;
          }
          &:last-child {
            padding-right: 0.32rem;
          }
        }
      }
      ul {
        color: #333333;
        li {
          font-size: 0.346667rem;
          line-height: 0.346667rem * 2;
          display: flex;
          justify-content: space-between;
          text-align: center;
          span {
            flex: 1;
            &:nth-child(2) {
              flex: 2;
            }
            em {
              color: #BF2424;
            }
          }
        }
      }
    }
    .use2 {
      margin-top: .346667rem * 2;
      .use-type {
        span {
          flex: 1;
          &:nth-child(2) {
            flex: 1;
          }
          &:first-child {
            padding-left: 0.32rem;
          }
          &:last-child{
            padding: 0;
          }
        }
      }
      ul {
        li {
          span {
            flex: 1;
            &:nth-child(2) {
              flex: 1;
            }
          }
        }
      }
    }
  }
  .payment{
    display: flex;
    line-height: 1.626667rem;
    text-align: center;
    font-size: .213333rem * 2;
    box-shadow: 0 -1px 1px rgba(0, 0, 0, 0.16);
    .left{
      width: 2.96rem * 2;
      background: #fff;
      em{
        margin-left: .32rem;
        font-size: 0.586667rem;
        font-weight: bold;
        color: #3B6D9C;
      }
    }
    .right{
      flex: 1;
      background: #3B6D9C;
      color: #FFFFFF;
      font-weight: bold;
    }
  }
};
.temporary{
  height: 3.973333rem * 2;
  overflow-y: scroll;
  margin-top: .16rem * 2;
}
</style>
